/**
 * 게임별 지면 색과 로고.
 *
 * 뉴스레터에서 게임 단위로 이야기가 갈릴 때 GameSection 이 쓰는 값이다.
 * 로고가 있으면 제목 자리에 로고를 그리고(부제까지 로고에 들어 있다), 없으면
 * title 을 글자로 쓴다. 로고 원본은 바삭클라우드의 각 게임 폴더에 있다.
 * 색은 각 게임의 키 비주얼에서 가져왔다 — 바탕(bg)은 키 비주얼의 주조색을
 * 흰 바탕에 아주 옅게 얹은 정도, 강조(accent)는 같은 계열에서 작은 글자로도
 * 4.5:1 을 넘기도록 어둡게 잡은 값이다. 잉크 색은 바꾸지 않는다.
 */
export const GAMES = {
  jobSeeker: {
    title: "취준생 키우기",
    logo: { src: "/newsletter/logos/job-seeker.png", height: 124 },
    bg: "#e9f0fb",
    accent: "#2f62c9",
  },
  studentMaker: {
    title: "수험생 키우기",
    logo: { src: "/newsletter/logos/student-maker.png", height: 124 },
    bg: "#fdeee0",
    accent: "#a8500e",
  },
  galaxy: {
    title: "은하원정대",
    bg: "#e3f0ef",
    accent: "#0f6b6d",
  },
  yeonae: {
    title: "연애혁명 키우기",
    bg: "#fdecf2",
    accent: "#c22e68",
  },
};
